import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

/* eslint-disable */
export default {
  /**
   * Inicializa hotjar
   * @param {*} id ID do Hotjar
   * @param {*} sv Versão do Hotjar
   */
  initialize: function (dns, env) {
    Sentry.init({
      dsn: dns,
      integrations: [new Integrations.BrowserTracing()],
      environment: env,
      beforeSend: (event) => {
        if (['production'].includes(env)) {
          return event;
        }
        return null;
      },
      tracesSampleRate: 1.0,
    });
  }
};